import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  InputSignal,
  InputSignalWithTransform,
  OutputEmitterRef,
  booleanAttribute,
  input,
  output
} from '@angular/core';

import {
  TiimePropertyDirective,
  TiimePropertiesDirective,
  TiimeIconPropertyDirective,
  TiimeIconModule,
  TiimeTooltipModule,
  TiimeButtonModule,
  TiimeListModule,
  TiimeEmptyStateModule,
  TiimeProgressSpinnerModule
} from 'tiime-material';

import { ContractStatus } from '@gi/enums/contract-status.enum';
import { Contract } from '@gi/models/contract';
import { ChangeContractStatusType } from '@modules/core/facades/contract.facade';
import { BooleanInputType } from '@modules/core/types/boolean-input.type';
import { ColumnNames } from '@modules/opportunities/contracts/contracts.columns';
import { BusinessUserSlugComponent } from '@shared-components/business-user-slug/business-user-slug.component';
import { ContractStatusSelectComponent } from '@shared-selectors/contract-status-select/contract-status-select.component';

@Component({
  selector: 'app-contracts-container',
  standalone: true,
  imports: [
    CommonModule,
    TiimeTooltipModule,
    TiimePropertyDirective,
    TiimeIconPropertyDirective,
    TiimeIconModule,
    TiimeButtonModule,
    TiimeListModule,
    ContractStatusSelectComponent,
    BusinessUserSlugComponent,
    TiimeProgressSpinnerModule,
    TiimeEmptyStateModule
  ],
  templateUrl: './contracts-container.component.html',
  styleUrls: ['./contracts-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  hostDirectives: [TiimePropertiesDirective]
})
export class ContractsContainerComponent {
  readonly contracts: InputSignal<Contract[]> = input.required<Contract[]>();
  readonly canCreateContract: InputSignal<boolean> = input<boolean>(true);
  readonly emptyLabel: InputSignal<string> = input<string>('Aucun contrat');
  readonly updateStatusDisabled: InputSignalWithTransform<boolean, BooleanInputType> = input<boolean, BooleanInputType>(
    false,
    { transform: booleanAttribute }
  );

  readonly updateContract: OutputEmitterRef<Contract> = output<Contract>();
  readonly createContract: OutputEmitterRef<void> = output<void>();
  readonly changeContractStatus: OutputEmitterRef<ChangeContractStatusType> = output<ChangeContractStatusType>();

  readonly contractsDisplayedColumns = [ColumnNames.businessUnit, ColumnNames.status, ColumnNames.owner];

  emitUpdateContract(contract: Contract): void {
    this.updateContract.emit(contract);
  }

  emitCreateContract(): void {
    this.createContract.emit();
  }

  emitChangeContractStatus(contract: Contract, status: ContractStatus): void {
    this.changeContractStatus.emit({ contract, status });
  }
}
